import { apiClient } from './api-client';

// ========================================
// LinkedIn OAuth + Config
// ========================================

export const linkedinApi = {
  // Config (admin)
  saveConfig: (config: { clientId: string; clientSecret: string; redirectUri?: string }) =>
    apiClient.put<{ message: string }>('/linkedin/config', config),
  getConfig: () =>
    apiClient.get<{ configured: boolean; clientId: string | null; redirectUri: string | null }>('/linkedin/config'),

  // OAuth
  getAuthUrl: () => apiClient.get<{ authUrl: string }>('/linkedin/auth/url'),
  callback: (code: string, state?: string) => apiClient.post<{ status: string }>('/linkedin/auth/callback', { code, state }),
  disconnect: () => apiClient.delete<void>('/linkedin/auth'),
  getStatus: () => apiClient.get<{ status: string; connectedAt?: string }>('/linkedin/status'),

  // Jobs
  publishJob: (jobId: string) => apiClient.post<{ linkedinJobId: string }>(`/jobs/${jobId}/linkedin/publish`, {}),

  // Candidates
  searchCandidates: (jobId: string, criteria?: any, pagination?: any) =>
    apiClient.post<any>(`/jobs/${jobId}/linkedin/search`, { criteria, pagination }),
  listCandidates: (jobId: string, funnelStatus?: string) =>
    apiClient.get<any[]>(`/jobs/${jobId}/linkedin/candidates${funnelStatus ? `?funnelStatus=${funnelStatus}` : ''}`),
  updateTriage: (jobId: string, candidateId: string, triageStatus: string) =>
    apiClient.patch<void>(`/jobs/${jobId}/linkedin/candidates/${candidateId}`, { triageStatus }),
  getFunnelCounters: (jobId: string) =>
    apiClient.get<{ found: number; inmailSent: number; replied: number; interviewScheduled: number; interviewDone: number; responseRate: number }>(`/jobs/${jobId}/linkedin/funnel`),

  // InMail
  generateInMail: (jobId: string, candidateId: string, context: any) =>
    apiClient.post<{ inmail: { subject: string; body: string } }>(`/jobs/${jobId}/linkedin/candidates/${candidateId}/inmail`, { action: 'generate', ...context }),
  sendInMail: (jobId: string, candidateId: string, subject: string, body: string) =>
    apiClient.post<{ status: string }>(`/jobs/${jobId}/linkedin/candidates/${candidateId}/inmail`, { action: 'send', subject, body }),
  sendBatchInMail: (jobId: string, candidateIds: string[], context: any) =>
    apiClient.post<{ batchId: string; queued: number }>(`/jobs/${jobId}/linkedin/batch-inmail`, { candidateIds, ...context }),

  // Schedule
  createProposal: (jobId: string, candidateId: string, slots: any[], context?: any) =>
    apiClient.post<{ proposal: any }>(`/jobs/${jobId}/linkedin/candidates/${candidateId}/schedule`, { slots, ...context }),
  confirmSchedule: (jobId: string, candidateId: string, scheduleId: string, confirmedSlot: any) =>
    apiClient.patch<{ proposal: any }>(`/jobs/${jobId}/linkedin/candidates/${candidateId}/schedule/${scheduleId}`, { action: 'confirm', confirmedSlot }),
  cancelSchedule: (jobId: string, candidateId: string, scheduleId: string) =>
    apiClient.patch<void>(`/jobs/${jobId}/linkedin/candidates/${candidateId}/schedule/${scheduleId}`, { action: 'cancel' }),
  reschedule: (jobId: string, candidateId: string, scheduleId: string, newSlots: any[]) =>
    apiClient.patch<{ proposal: any }>(`/jobs/${jobId}/linkedin/candidates/${candidateId}/schedule/${scheduleId}`, { action: 'reschedule', newSlots }),
};


// ========================================
// Calendar OAuth + Config
// ========================================

export const calendarApi = {
  // Config (admin)
  saveGoogleConfig: (config: { clientId: string; clientSecret: string; redirectUri?: string }) =>
    apiClient.put<{ message: string }>('/calendar/google/config', config),
  saveOutlookConfig: (config: { clientId: string; clientSecret: string; redirectUri?: string; tenantId?: string }) =>
    apiClient.put<{ message: string }>('/calendar/outlook/config', config),
  getConfig: () =>
    apiClient.get<{
      google: { configured: boolean; clientId: string | null };
      outlook: { configured: boolean; clientId: string | null };
    }>('/calendar/config'),

  // OAuth
  getGoogleAuthUrl: () => apiClient.get<{ authUrl: string }>('/calendar/google/auth/url'),
  googleCallback: (code: string) => apiClient.post<void>('/calendar/google/auth/callback', { code }),
  getOutlookAuthUrl: () => apiClient.get<{ authUrl: string }>('/calendar/outlook/auth/url'),
  outlookCallback: (code: string) => apiClient.post<void>('/calendar/outlook/auth/callback', { code }),
  disconnect: () => apiClient.delete<void>('/calendar/disconnect'),
  getStatus: () => apiClient.get<{ provider: string | null; status: string }>('/calendar/status'),
  getAvailability: (startDate: string, endDate: string) =>
    apiClient.get<any[]>(`/calendar/availability?startDate=${startDate}&endDate=${endDate}`),
};
